module.exports = __webpack_public_path__ + "img/slide6_img2.83d3f325.png";